import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext.js";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      // AuthContext will handle success toast and state update
    } catch (error) {
      // AuthContext handles error toast
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "white",
        padding: "1rem",
        overflow: "auto",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem", fontWeight: "bold" }}>
          🎾 Tennis-Schule TC GW Am Kreuzberg
        </h1>
        <p style={{ fontSize: "1rem", maxWidth: "600px", margin: "0 auto" }}>
          Trainingsplan-Verwaltung
        </p>
      </div>

      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "2rem",
          boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <h2
          style={{
            color: "#333",
            marginBottom: "1rem",
            fontSize: "1.25rem",
            textAlign: "center",
          }}
        >
          Anmelden
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1rem" }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: "#555",
                fontWeight: "500",
              }}
            >
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "1rem",
                boxSizing: "border-box",
              }}
              placeholder="ihre.email@beispiel.de"
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: "#555",
                fontWeight: "500",
              }}
            >
              Passwort
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "1rem",
                boxSizing: "border-box",
              }}
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "0.875rem",
              background: loading ? "#9ca3af" : "#667eea",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background 0.2s",
            }}
            onMouseOver={(e) => {
              if (!loading) e.target.style.background = "#5568d3";
            }}
            onMouseOut={(e) => {
              if (!loading) e.target.style.background = "#667eea";
            }}
          >
            {loading ? "Anmeldung läuft..." : "Anmelden"}
          </button>
        </form>

        <div
          style={{
            marginTop: "1rem",
            paddingTop: "1rem",
            borderTop: "1px solid #e0e0e0",
            textAlign: "center",
            color: "#666",
            fontSize: "0.75rem",
          }}
        >
          <p>
            Bei Problemen mit der Anmeldung wenden Sie sich bitte an den
            Administrator.
          </p>
        </div>
      </div>

      <div
        style={{
          marginTop: "1rem",
          textAlign: "center",
          color: "rgba(255,255,255,0.8)",
          fontSize: "0.75rem",
        }}
      >
        <p>TC GW Am Kreuzberg © {new Date().getFullYear()}</p>
      </div>
    </div>
  );
};

export default Login;
